// 点击编辑
const clickEdit = {
    gotoPage: function (type, id) {
        var url, title;
        if (type === 5 || type === 6) {
            if (id === 0) {
                url = "/cm-sites/pms/mediaFusion/atlasdetail.html";
                title = "新建图集";
            } else {
                url = "/cm-sites/pms/mediaFusion/atlasdetail.html?mfId=" + id;
                title = "编辑图集";
            }
        } else if (type === 7 || type === 8) {
            if (id === 0) {
                url = "/cm-sites/pms/mediaFusion/videodetail.html";
                title = "新建视频";
            } else {
                url = "/cm-sites/pms/mediaFusion/videodetail.html?mfId=" + id;
                title = "编辑视频";
            }
        } else if (type === 9) {
            if (id === 0) {
                url = "/cm-sites/pms/mediaFusion/audiodetail.html";
                title = "新建音频";
            } else {
                url = "/cm-sites/pms/mediaFusion/audiodetail.html?mfId=" + id;
                title = "编辑音频";
            }
        } else {
        }
        window.openFull(url, title, () => { }, {
            shade: 0.3,
            area: [
                parseInt(document.body.clientWidth * 0.6) + "px",
                parseInt(document.body.clientHeight * 0.95) + "px",
            ],
        });
    }
}
export default clickEdit